
class clStatus
{
	private ActiveStatus: number;
	private LockedStatus: number;
	private VisibleStatus: number;

	private Account: Wollmilch.Account;

	constructor( vAccount: Wollmilch.AccountObject )
	{
		this.ActiveStatus 	= 0b100;
		this.LockedStatus 	= 0b10;
		this.VisibleStatus	= 0b1;

		this.Account = new Wollmilch.Account( vAccount );
	}

	// setzt den Status
	public setActiveStatus()
	{
		this.sendStatusData( 'activate' );
	}
	public setInactiveStatus()
	{
		this.sendStatusData( 'deactivate' );
	}

	public setLockedStatus()
	{
		this.sendStatusData( 'lock' );
	}
	public setUnlockStatus()
	{
		this.sendStatusData( 'unlock' );
	}

	public setVisibleStatus()
	{
		this.sendStatusData( 'visible' );
	}
	public setInvisibleStatus()
	{
		this.sendStatusData( 'invisible' );
	}

	public setDeleteStatus()
	{
		this.sendStatusData( 'delete' );
	}
	public setUndeleteStatus()
	{
		this.sendStatusData( 'undelete' );
	}

	// eigentliches Speichern
	private sendStatusData( vAction: string )
	{
		new Wollmilch.AJAX(
		{
			url: "account/" + vAction + "/" + this.Account.ID,
			method: 'PATCH',
			data: '',
			on: {
				success( text )
				{
					let obj: Wollmilch.ResponseObject;
					try
					{
						obj = JSON.parse( text );
					}
					catch ( e )
					{
						alert( e.getMessage() );
						return;
					}
					if ( obj.success )
					{
						app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( "Account.Status.SUCCESS" ) ], context: 'success' });
					}
				},
				failed( status, xhr )
				{
					app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [xhr.responseText], context: 'danger' });
				}
			}
		}
		).send();
	}

}
